// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors.329bd2e12a5b13283858.js";
	// return url for filenames based on template
	return "" + ({"296":"__federation_expose_OnboardingApp","644":"react","874":"antd"}[chunkId] || chunkId) + "." + {"296":"1cda9bfbe0e1adfafb35","354":"e0234a8ebebe1653c31f","432":"63072a6545288c84e9c1","644":"b9721780c684243d7760","874":"63108cdec820b06d5976"}[chunkId] + ".chunk.js";
};